import { useContext } from "react";
import DashboardContext from "../contexts/dashboardContext";

export const useFilterContext = () => {
  const context = useContext(DashboardContext);
  return context;
};
